import * as LocalesActions from '../actions/locales.actions';
import { Locale } from '../models/locale.model';

export interface State {
  updateRequired: boolean;
  errorMessage: string;
  data: Locale[];
}

export const initialState: State = {
  updateRequired: true,
  errorMessage: '',
  data: [
    {
      locale: "en_US",
      title: "English"
    }
  ],
};

export function reducer(
  state = initialState,
  action: LocalesActions.ActionList
): State {
  switch (action.type) {
    case LocalesActions.ActionTypes.Update: {
      return { ...state, updateRequired: true, errorMessage: '' };
    }

    case LocalesActions.ActionTypes.Receive: {
      return {
        ...state,
        updateRequired: false,
        data: action.payload.errorMessage ? state.data : action.payload.locales,
        errorMessage: action.payload.errorMessage,
      };
    }

    default: {
      return state;
    }
  }
}
